import { createCmsUrl } from '@/api/cms/base';
import { fetcherCMS } from '@/modules/api';

export interface ITournamentGame {
  tournamentGameCategories?: string;
  tournamentGameIds?: string;
}

export const getTournamentGameUrl = createCmsUrl({ path: 'tournament-game' });

export const tournamentGame = async () => {
  const response = await fetcherCMS<ITournamentGame>(getTournamentGameUrl);
  return { data: response };
};
